export default __webpack_public_path__ + "static/media/Axe_4.38aec418.png";